import React from 'react';
import _ from "underscore";
import moment from "moment";

import Container from "react-bootstrap/Container";
import Carousel from "react-bootstrap/Carousel";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Countdown from 'react-countdown';
import ReactHtmlParser from "react-html-parser";
import {setCookie} from "../common/utils";

class TopCarouselPromo extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            carousel_interval: 5000 // 5 seconds
        }

        this.Carousel = React.createRef()
        this.dismissAlert = this.dismissAlert.bind(this)
    }

    dismissAlert(key){
        const { alerts } = this.props;
        const headerHeight = document.getElementById('headroom').offsetHeight;
        const topPromoHeight = this.Carousel.current.offsetHeight;

        setCookie('top-banner-dismissed', true, 1, 'hours');

        this.setState({
            alerts: alerts
        })

        this.props.headerHeight(headerHeight - topPromoHeight);
    }

    render(){
        const { carousel_interval } = this.state;
        const { alerts, mobile } = this.props;

        return (
            <Carousel
                key={alerts.length}
                className="top-carousel-promo"
                interval={carousel_interval}
                controls={false}
                indicators={false}
            >
                { _.map(alerts, (alert, key) => {
                    return (
                        <Carousel.Item key={key}>
                            <CarouselItem
                                idx={key}
                                alert={alert}
                                mobile={mobile}
                                dismissAction={this.dismissAlert}
                            />
                        </Carousel.Item>
                    )
                })}
            </Carousel>
        );
    }
}

class CarouselItem extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            isHidden: true
        }

        this.isHidden = this.isHidden.bind(this);
    }

    isHidden(e) {
        this.setState({isHidden: e})
    }

    countDownRenderer ({ formatted, completed, dismissAction }) {
        const {hours, minutes, seconds} = formatted;

        if (completed) {
            dismissAction();
            return null;
        } else {
            return (
                <span
                    className="top-carousel-promo__promo-text--counter"
                >
                    {hours}:{minutes}:{seconds}
                </span>
            )
        }
    };

    render(){
        const { idx, alert, mobile, dismissAction } = this.props;
        const { isHidden } = this.state;
        const today = moment.utc(new Date());
        const expiration_day = alert.end_date ? moment.utc(alert.end_date) : '';
        const expires_in = expiration_day ? moment.duration(expiration_day.diff(today)).asHours() : '';

        return (
            <Container>
                <div className="top-carousel-promo__item">
                    <div className="top-carousel-promo__promo-text">
                        {ReactHtmlParser(alert.title)}&nbsp;
                        {alert.description &&
                        <OverlayTrigger
                            rootClose
                            placement={"bottom"}
                            trigger={mobile?'click':['hover','focus']}
                            onEnter={() => this.isHidden(false)}
                            onExited={() => this.isHidden(true)}
                            overlay={
                                <Popover id={`tooltip-${idx}`}>
                                    <Popover.Content>
                                        {alert.description}
                                    </Popover.Content>
                                </Popover>
                            }
                        >
                            <span className="top-carousel-promo__promo-text--popover">{isHidden?'Show More':'Show Less'}</span>
                        </OverlayTrigger>
                        }
                        {alert.show_countdown && expires_in > 0 && expires_in <= 24 &&
                            <>
                                {ReactHtmlParser(alert.countdown_prefix)}
                                <Countdown
                                    date={expiration_day.toISOString()}
                                    renderer={props => this.countDownRenderer({...props, dismissAction: dismissAction})}
                                    daysInHours={true}
                                />
                            </>
                        }
                    </div>
                    {alert.can_dismiss &&
                    <div
                        className="top-carousel-promo__close-button"
                        onClick={() => dismissAction(idx)}
                    >
                        <span className="icon-close"></span>
                    </div>
                    }
                </div>
            </Container>
        );
    }
}

export default TopCarouselPromo;
